import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';

const LetsTakeTheBus = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: '#fff',
        minHeight: '100vh',
        maxWidth: 900,
        mx: 'auto',
      }}
    >
      <Typography variant="h3" gutterBottom>
        Let’s Take the Bus, Miami Lakes! – 9/15/2025
      </Typography>

      <Typography paragraph>
        On Monday, September 15, the Town of Miami Lakes, alongside representatives from the
        Miami-Dade Transportation Planning Organization (TPO), Miami-Dade Department of
        Transportation and Public Works (DTPW), and Transit Alliance, conducted a transit audit to
        evaluate accessibility, safety, and rider experience across the town’s transit network.
      </Typography>

      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-lets-take-the-bus-event1.jpg`}
          alt="The Project Group Boarding the Bus at Stop 8316"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" sx={{ mt: 1, textAlign: 'center' }}>
          The Project Group Boarding the Bus at Stop 8316
        </Typography>
      </Box>

      <Typography paragraph>
        The audit focused on several key components of local transit service, including the Freebee
        on-demand service and existing bus routes. The event began at Veteran's Park, where Freebee
        vehicles are stored and charged overnight. The group met with the Freebee regional manager
        and drivers to gain insights into the service’s daily operations.
      </Typography>

      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-lets-take-the-bus-event2.jpg`}
          alt="Conversations Between the Project Group and Freebee Staff"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" sx={{ mt: 1, textAlign: 'center' }}>
          Conversations Between the Project Group and Freebee Staff
        </Typography>
      </Box>

      <Typography paragraph>
        The team also reviewed ridership patterns and assessed the condition of four bus stops along
        NW 67th Avenue, from Miami Lakeway S to Windmill Gate Road. To better understand the rider
        experience, the group rode Route 183 in both directions along NW 67th Avenue.
      </Typography>

      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-lets-take-the-bus-event3.jpg`}
          alt="The Project Group Waiting for the Northbound Route 183 Bus at Stop 8316"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" sx={{ mt: 1, textAlign: 'center' }}>
          The Project Group Waiting for the Northbound Route 183 Bus at Stop 8316
        </Typography>
      </Box>

<Typography paragraph>
  To document the findings, an ArcGIS StoryMap was developed to highlight the findings of the
  audit. The StoryMap includes mapped observations of bus stop conditions, Freebee service
  operations, and transit accessibility along NW 67th Avenue. The story map can be found at:{' '}
  <Link
    href="https://storymaps.arcgis.com/stories/f1c5d848a01e4b719ce6da17125ce89a"
    target="_blank"
    rel="noopener noreferrer"
  >
    Let’s Take the Bus, Miami Lakes!
  </Link>
</Typography>


      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-lets-take-the-bus-event4.jpg`}
          alt="Members of the Project Group in a Freebee Vehicle During the Audit"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" sx={{ mt: 1, textAlign: 'center' }}>
          Members of the Project Group in a Freebee Vehicle During the Audit
        </Typography>
      </Box>

      <Typography paragraph>
        We invite you to continue participating as this public engagement effort just started. Join
        the conversation through our social media channels.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <InstagramIcon color="action" />
          <Link
            href="https://www.instagram.com/miamilakesvisionzero"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvisionzero
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <XIcon color="action" />
          <Link
            href="https://twitter.com/miamilakesvz"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvz
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FacebookIcon color="action" />
          <Link
            href="https://www.facebook.com/share/1HS7Sy2A9Z/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            Vision Zero Miami Lakes
          </Link>
        </Box>
      </Box>

      <Typography paragraph>
        Be part of the conversation and participate by completing the community survey using{' '}
        <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
          this survey link
        </Link>
        .
      </Typography>

      <Typography paragraph>
        Our website and social media channel continue posting project updates and upcoming events.
      </Typography>

      <Typography paragraph>
        Para español:{' '}
        <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
          haga clic aquí
        </Link>{' '}
        (seleccione español)
      </Typography>
    </Box>
  );
};

export default LetsTakeTheBus;
